export default __webpack_public_path__ + "static/media/dozule20.360efca2.jpg";